import { Routes } from '@angular/router';

export const legalRoutes: Routes = [
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/terms-page/terms-page.component').then(m => m.TermsPageComponent),
    title: 'EVready Energy - Terms and Conditions'
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/privacy-page/privacy-page.component').then(m => m.PrivacyPageComponent),
    title: 'EVready Energy - Privacy Policy'
  },
  {
    path: 'install-terms',
    loadComponent: () =>
      import('./pages/install-terms-page/install-terms-page.component').then(
        m => m.InstallTermsPageComponent
      ),
    title: 'EVready Energy - Installation Terms and Conditions'
  },
  {
    path: 'equipment-terms',
    loadComponent: () =>
      import('./pages/equipment-terms-page/equipment-terms-page.component').then(
        m => m.EquipmentTermsPageComponent
      ),
    title: 'EVready Energy - Equipment Purchasing Terms and Conditions'
  },
  {
    path: 'renewal-terms',
    loadComponent: () =>
      import('./pages/renewal-terms-page/renewal-terms-page.component').then(
        m => m.RenewalTermsPageComponent
      ),
    title: 'EVready Energy - Renewal Terms and Conditions'
  },
  {
    path: 'terms-and-conditions',
    redirectTo: 'terms',
    pathMatch: 'full'
  },
  {
    path: 'privacy-policy',
    redirectTo: 'privacy',
    pathMatch: 'full'
  }
];
